import React from "react";
import irsadulHaccLarge from '../../../assets/books/kapaklar/irsadul-hacc_600.jpg';
import irsadulHaccMini from '../../../assets/books/kapaklar/irsadul-hacc-300.jpg';
export const IrsadulHacDescription = (props: any) => {
    return (
        <div className="summary-description">
            <div className="book-image">
                <img
                    src={irsadulHaccLarge}
                    alt="İrşad'ül Hacc"
                    srcSet={`${irsadulHaccMini} 300w, ${irsadulHaccLarge} 600w`}
                    sizes={"(max-width: 600px) 300px,  600px"}
                />
            </div>

            <p className="summary-title">HAC’DAN NE ANLAMAMIZ LAZIM?</p>
            <p style={{ marginTop: 0 }}>
                Hac ve Umre, insanın yaratılış tiyatrosudur. İslam mektebidir.
                Allah lisanıyla harekettir. Aslî hareketler Adem, İbrahim,
                Hacer, İsmail ve İblis, Allah'a ibadet yaratılışımızın gayesi ve
                kalbimizdeki imanın göstergesidir. Yerine getirmemiz gereken bu ulvî
                görevi doğru olarak öğrenmek büyük önem taşımaktadır. İslam'ın beş temel
                şartından biri olan hac ibadeti kelime-i tevhid-i, namazı, orucu,
                zekâtı bütün ibadeti dirilttiği için Hz. Rasulullah (S.A.V) kabul olan
                haccın karşılığı ancak cennet buyurmuşlardır.
            </p>
        </div>
    )
}


export const IrsadulHacSummaryDescription = (props: any) => {
    return (
        <p>
            Hac ve Umre, insanın yaratılış tiyatrosudur. İslam mektebidir.
            Allah lisanıyla harekettir. Aslî hareketler Adem, İbrahim,
            Hacer, İsmail ve İblis, Allah'a ibadet yaratılışımızın gayesi ve
            kalbimizdeki imanın göstergesidir. Yerine getirmemiz gereken bu ulvî
            görevi doğru olarak öğrenmek büyük önem taşımaktadır. İslam'ın beş temel
            şartından biri olan hac ibadeti kelime-i tevhid-i, namazı, orucu,
            zekâtı bütün ibadeti dirilttiği için Hz. Rasulullah (S.A.V) kabul olan
            haccın karşılığı ancak cennet buyurmuşlardır.
        </p>
    )
}